import { ReactElement } from "react";
import { DateString } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import styles from "./NameAndDate.module.less";
import { UserIdentityModel } from "client/Api/UserProfile/service";
import { TimeZone } from "client/DateAndTime/timezones";
import { NameAndPronouns } from "../../NameAndPronouns";

export type NameAndDateProps = {
	authorUserInfo: UserIdentityModel;
	publicationTime: Date;
	timezone: TimeZone;
};

export const NameAndDate = (props: NameAndDateProps): ReactElement => {
	const {
		authorUserInfo,
		publicationTime,
		timezone
	} = props;

	return (
		<div className={styles.root}>
			<div className={styles.nameContainer}>
				<NameAndPronouns
					authorUserInfo={authorUserInfo}
					nameSize="small"
				/>
			</div>

			<span
				{...setTrackingId("timestamp")}
				className={styles.timestamp}
			>
				<DateString
					value={publicationTime}
					format="RelativeTimestamp"
					timezone={timezone}
				/>
			</span>
		</div>
	);
};
NameAndDate.displayName = "NameAndDate";
